import React from 'react';
import { Cpu, CircleCheck, Zap } from 'lucide-react';
import { features } from '../../data/mock';

const iconMap = {
  Cpu: Cpu,
  CircleCheck: CircleCheck,
  Zap: Zap
};

const FeaturesSection = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Why Choose NICE Grading?
          </h2>
          {/* IMPROVED: Changed from #B2B4B2 to text-gray-600 for better contrast (4.5:1+) */}
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Professional grading built on precision, technology and expertise. We deliver the quality you expect without the wait time or hidden costs you despise.
          </p>
        </div>

        {/* Feature Cards */}
        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <div 
                key={feature.id}
                className="bg-white rounded-xl p-8 border border-gray-200 hover:shadow-lg transition-shadow duration-300"
              >
                <div className="w-14 h-14 bg-[#003594] rounded-xl flex items-center justify-center mb-6">
                  <IconComponent className="w-7 h-7 text-white" />
                </div>
                {/* IMPROVED: Using font-bold (700) for headings */}
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {feature.title}
                </h3>
                {/* IMPROVED: Changed from #B2B4B2 to text-gray-600 for better contrast */}
                <p className="text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
